import React from 'react';
import { observer } from 'mobx-react';
import { Neo } from '@singularsystems/neo-react';
import { Data } from '@singularsystems/neo-core';

import Address from '../Models/Address';

interface IAddressComponentProps<TCountry> {
    address: Address;
    showValidate: Boolean;
    countries: Data.IAsyncDataSource<TCountry[]>;
}

@observer
export default class AddressComponent<TCountry> extends React.Component<IAddressComponentProps<TCountry>> {

    render() {
        return (
            <div>
                {this.props.showValidate &&
                    <Neo.FormGroup bind={this.props.address.meta.validateAddress} />
                }
                <Neo.FormGroup bind={this.props.address.meta.street} />
                <Neo.FormGroup bind={this.props.address.meta.city} />
                <Neo.FormGroup bind={this.props.address.meta.code} />
                <Neo.FormGroup bind={this.props.address.meta.stateProvince} />
                <Neo.FormGroup bind={this.props.address.meta.countryId}
                    select={{ itemSource: this.props.countries }} />
            </div>
        )
    }
}
